<template>
    <div class="sale-content">
        <NavBar class="navbar"></NavBar>
        <div class="center-box">

        
        <div class="info-box">
            <div class="mandy-top">
                <h3>{{$t('Thank you for choosing us')}} </h3>
                <span>{{$t('Your Course Adviser will contact you shortly')}} </span>
            </div>
            <div class="mandy-icon">
                <img src="../assets/img/avatar.png" alt="" />
                    <h3>{{ info.name }}</h3>
                    <span>{{ info.describe }}</span>
            </div>
            <div class="mandy-msg">
                <div class="lo-icon">
                    <img src="../assets/img/message_3.png" alt="" />
                    <span class="lo-text">{{ info.email }}</span>
                </div>
                <div class="lo-icon">
                    <img src="../assets/img/Calling.png" alt="" />
                    <span class="lo-text">{{ info.mobile }}</span>
                </div>
                <div class="lo-icon">
                    <img src="../assets/img/WeChat_logo_icon 1.png" alt="" />
                    <span class="lo-text">{{ 'Wechat ID: '+info.wechat }}</span>
                </div>
            </div>
            <div class="m-center">
                <div class="qr-tip" v-if="$i18n.locale === 'en'" style="text-align:center;color:#6B7280;font-size:14px;line-height:20px;margin:16px 0 0;font-family:'Sofia Pro';">Use Wechat to scan</div>
                <div class="qr-code">
                    <img :src="info.qr_code" alt="" />
                </div>
            </div>
            <div v-if="$i18n.locale !== 'en'" style="text-align:center;margin:10px 0">请扫码添加顾问老师微信</div>
        </div>
		<div class="mindy-button">
            <button class="wp-button" @click="goback">
                <span> {{$t('Back')}} </span>
            </button>
        </div>
        </div>
	</div>
</template>
<script>
    import { getSaleInfo } from '../api';
	import { getStore, keys } from '../store';
    import NavBar from '@/components/NavBar.vue';
	export default {
		name: 'nuinfo',
        components: {
            NavBar,
        },
		data() {
			return {
				info: {
					name: '',
					describe: '',
					email: '',
					mobile: '',
					wechat: '',
					qr_code: '',
				},
                invite_code:''
			};
		},
        created(){
			function gethtmlfontsize(){
				// 三个步骤:
				// 1.获取html的高,
				let htmlheight=document.documentElement.clientHeight || document.body.clientHeight;//有些浏览器documentElement获取不到,那就使用后面的body
				console.log( htmlheight);    
				// 2.htmlDom
				let htmlDom=document.getElementsByTagName("html")[0]
				// console.log(htmlDom);
				//3.设置根元素样式
				htmlDom.style.fontSize=10* htmlheight/375+'px';
				console.log(htmlDom.style.fontSize)
				htmlDom.style.height = '100%';
			}
				// 调用一次
				gethtmlfontsize();
				// 添加监听事件(resize是监听的意思)
				window.addEventListener('resize',gethtmlfontsize)
		},
		async mounted() {
            this.invite_code=this.$route.query.invite_code
            this.info =await getSaleInfo(this.invite_code)
			// this.info = getStore(keys.userInfo);
            console.log(getStore(keys.userInfo))
            console.log(this.info)
			// this.info = user.salesperson_info;
		},
        methods:{
            goback(){
                this.$router.push('/login')
            }
        }
	};
</script>

<style lang="less" scoped>
// .navbar{
//     position: relative;
// }
	.sale-content {
        width:100%;
        height:100vh;
        position: relative;
        background: #F5F5F5;
		// background-color: #f9f9f9;
		// height: 150px;
		// text-align: center;
        >img{
            width: 557px;
            height: 557px;
            position: absolute;
            top:50%;
            left:50%;
            margin-left:-280px;
            margin-top:-280px;

        }
        .info-box{
            width: 25rem;
            // height:617px;
            // position: absolute;
            // left:50%;
            // top:50%;
            // margin-left:-315px;
            // margin-top:-200px;
            margin: 0 auto 0;
            padding:0.95rem 0;
            background: #F5F5F5;
            border: 1px solid #D8D8D8;
            box-sizing: border-box;
            box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
            border-radius: 5px;
            .mandy-top{
                margin-bottom: 1.1rem;
                h3{
                    font-family:Sofia Pro Bold;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 1.2rem;
                    line-height: 1.5rem;
                    text-align: center;
                    margin: 0;
                    color: #111827;
                }
                span{
                    font-family: 'Sofia Pro';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.65rem;
                    line-height: 1.2rem;
                    text-align: center;
                    color: #6B7280;
                    font-feature-settings: 'salt' on;
                    display: block;
                    margin-top: 0.35rem;
                }
            }
        }
	}

	.mandy-icon {
		display: flex;
		align-items: center;
        flex-direction: column;
        img{
            width:3rem;
            height:3rem;
        }
        h3{
            margin:6px 0;
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 0.85rem;
            line-height: 0.85rem;
            color: #0B1D33;
        }
        span{
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 0.75rem;
            color: #0B1D33;
        }
	}
    .mandy-msg{
        // width:300px;
        display: table;
        margin:0px auto ;
    }
    .lo-icon{
		display: flex;
		align-items: center;
        margin:0.93rem auto;
        img{
            width:0.85rem;
            height:0.85rem;
            margin-right:23px;
        }
        &:first-child img{
            width:0.85rem;
            height:0.8rem;
        }
        &:last-child img{
            width:1.2rem;
            height:0.95rem;
        }
        span{
            display: inline-block;
            width: 100%;
            word-break: break-word;
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 0.8rem;
            line-height: 0.75rem;
            color: #0B1D33;
        }
    }
	.qr-code {
		height: 6.8rem;
		width: 6.8rem;
		line-height: 6.8rem;
		// background: #4b69fe;
		border-radius: 4px;
		margin: auto;
		text-align: center;
		img {
			width: 6.8rem;
			height: 6.8rem;
			vertical-align: middle;
		}
	}
    .wp-button{
        height: 2.3rem;
    }
    .mindy-button{
        width:25rem;
        height:2.0rem;
        // position:absolute;
        // bottom: 3vh;
        // left: calc(50% - 296px);
        margin: 1.4rem auto 0;
        padding: 0.1rem 0;
        button{
            background: #4B4EFC;
            border: 2px solid #fff;
            border-radius: 43px;
            cursor: pointer;
            span{
                font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 500;
                font-size: 0.85rem;
                line-height: 1.3rem;
                color: #FFFFFF;
            }
        }
    }
</style>

<style lang="less" scoped>
	@media screen and (min-width: @device) {
	.center-box{
        display: flex;
        flex-direction:column;
        justify-content:center;
        height: calc(100vh - 100px);
    }
		
	}

	@media screen and (max-width: @device) {
        .sale-content {
        width:100%;
        height:100vh;
        position: relative;
        background: #F5F5F5;
		// background-color: #f9f9f9;
		// height: 150px;
		// text-align: center;
        >img{
            width: 557px;
            height: 557px;
            position: absolute;
            top:50%;
            left:50%;
            margin-left:-280px;
            margin-top:-280px;

        }
        .info-box{
            margin: 0 auto 0;
            padding:0.95rem 0;
            background: #F5F5F5;
            border: 1px solid #D8D8D8;
            box-sizing: border-box;
            box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
            border-radius: 5px;
            .mandy-top{
                h3{
                    font-family:Sofia Pro Bold;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 28px;
                    text-align: center;
                    margin: 0;
                    color: #111827;
                }
                span{
                    font-family: 'Sofia Pro';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 26px;
                    text-align: center;
                    color: #6B7280;
                    font-feature-settings: 'salt' on;
                    display: block;
                    margin-top: 8px;
                }
            }
        }
	}

	.mandy-icon {
		display: flex;
		align-items: center;
        flex-direction: column;
        img{
            width:70px;
            height:70px;
        }
        h3{
            margin:6px 0;
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 18px;
            color: #0B1D33;
        }
        span{
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            color: #0B1D33;
        }
	}
    .mandy-msg{
        // width:300px;
        display: table;
        margin:0px auto ;
    }
    .lo-icon{
		display: flex;
		align-items: center;
        margin:20px auto;
        img{
            width:18px;
            height:18px;
            margin-right:23px;
        }
        &:first-child img{
            width:18px;
            height:16px;
        }
        &:last-child img{
            width:25px;
            height:21px;
        }
        span{
            display: inline-block;
            width: 100%;
            word-break: break-word;
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 15px;
            color: #0B1D33;
        }
    }
	.qr-code {
		height: 146px;
		width: 146px;
		line-height: 146px;
		// background: #4b69fe;
		border-radius: 4px;
		margin: auto;
		text-align: center;
		img {
			width: 146px;
			height: 146px;
			vertical-align: middle;
		}
	}
    .mindy-button{
        height:60px;
        position:absolute;
        bottom:20px;
        padding: 5px 0;
        button{
            background: #4B4EFC;
            border: 2px solid #fff;
            border-radius: 43px;
            cursor: pointer;
            span{
                font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
                color: #FFFFFF;
            }
        }
    }

        .sale-content {
            width: 100vw;
            height: 740px;
            position: relative;  
            background: #F5F5F5;         
            .info-box{
                width:100vw;
                height:initial;
                position:absolute;
                top:91px;
                left:0;
                margin-left:0;
                margin-top:0;
                padding:20px 0;
                // background: #FFFFFF;
                // border: 0.666332px solid #F2F2F2;
                border: none;
                box-sizing: border-box;
                box-shadow: none;
                border-radius: 0;
                .mandy-top{
                    margin-bottom: 32px;
                    h3{
                        font-size: 24px;
                    }
                }
                .mandy-icon{
                    img{
                        width: 55px;
                        height: 55px;
                    }
                    h3{
                        margin: 12px 0 6px;
                    }
                }
                .mandy-msg{
                    margin: 32px auto;
                    .lo-icon{
                        margin: 14px 0;
                        span{
                            font-size: 14px;
                            line-height: 17px;
                        }
                    }
                }
                .m-center{
                    .qr-code{
                        width: 125px;
                        height: 125px;
                        line-height: 125px;
                        img{
                            width: 125px;
                            height: 125px;
                        }
                    }
                }
                
                
            }
        }
        .mindy-button{
            top: 660px;
            width: 85vw;
            margin: 0 auto;
            left: calc(50% - 42.5vw);
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/nuinfo.vue